import React from "react";
import {ConnectAccountOnboarding, ConnectComponentsProvider} from "@stripe/react-connect-js";
import {useState} from "react";
import {stripeServices} from "../../../../../services/stripeServices";
import {loadConnectAndInitialize} from "@stripe/connect-js";
import Loading from "../../../../../components/Loading";
import {Trans, useTranslation} from "react-i18next";
import StripeConfigSVG from "../../../../../components/svg/Actions/StripeConfig";

const StripeConfig = ({onFinish}) => {

    const {t} = useTranslation();

    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState(false);
    const [stripeConnectInstance, setStripeConnectInstance] = useState();

    const handleStartConfig = async () => {
        setLoading(true)
        setActive(true)
        stripeServices.getAccountSession()
            .then(({account_id, client_secret}) => {
                console.log("setting stripeConnectInstance", account_id, client_secret)
                setStripeConnectInstance(
                    loadConnectAndInitialize({
                        publishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
                        fetchClientSecret: async () => {
                            return client_secret
                        },
                        fonts: [{
                            family: "Inter",
                            src: "url(https://fonts.googleapis.com/css2?family=Inter:wght@400&display=swap)",
                        }],
                        locale: localStorage.getItem('i18nextLng'),
                        appearance: {
                            overlays: "dialog",
                            variables: {
                                colorPrimary: "#dcefec",
                                fontSizeBase: "18px",
                                fontFamily: "Inter, sans-serif",
                            },
                        },
                    })
                );
            }).catch((e) => {
            console.error("Error on useStripeConnect:", e);
            setActive(false);
            setStripeConnectInstance(null);
        }).finally(() => {
            setLoading(false)
        })
    }

    return (<div className={"stripe-config-container text-center" + (active ? " active" : "")}>
        {loading && <Loading relative cover={0.5}/>}
        {(!stripeConnectInstance && !loading) && <>
            <StripeConfigSVG />
            <h3 className="verification-container__title">{t("verification.stripeConnect.title")}</h3>
        <p className="verification-container__description">
            {t("verification.stripeConnect.description")}
        </p></>}
        {stripeConnectInstance ?
            <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                <ConnectAccountOnboarding
                    onExit={onFinish}
                />
            </ConnectComponentsProvider>
            :
            (loading ? null :
                <button type={'button'} className={'btn btn-primary full'} style={{marginTop: "30px"}} disabled={loading}
                        onClick={handleStartConfig}>{t("verification.start")}
                </button>)
        }
    </div>)
}

export default StripeConfig;
